import { render, staticRenderFns } from "./FormPropertiesViewer.vue.js?vue&type=template&id=b8a195aa&scoped=true!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormPropertiesViewer.vue?vue&type=template&id=b8a195aa&scoped=true"
import script from "./FormPropertiesViewer.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormPropertiesViewer.vue?vue&type=script&lang=js"
export * from "./FormPropertiesViewer.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormPropertiesViewer.vue?vue&type=script&lang=js"
import style0 from "./FormPropertiesViewer.vue.scss?vue&type=style&index=0&id=b8a195aa&prod&scoped=true&lang=scss!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormPropertiesViewer.vue?vue&type=style&index=0&id=b8a195aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a195aa",
  null
  
)

export default component.exports